import React from "react";
import PropTypes from "prop-types";
import { selectCompanyRegistration } from "../../../redux/preferences/selectors";
import { connect, useSelector } from "react-redux";
import {
  approveMaterialRequest,
  deleteMaterialRequest,
  getAllMaterialRequests,
  getMaterialRequests,
  rejectMaterialRequest
} from "../../../services/api/materialRequests";
import { toImmutable } from "../../../libs/immutable-transformer";
import { Trans } from "react-i18next";
import ListView from "../../../base/ListView";
import CreateMaterialRequestButton from "../../shared/materialRequests/CreateMaterialRequestButton";
import Confirm from "../../../base/Confirm";
import { getRegistrationMaterialCategories } from "../../../services/api/registrationMaterialCategories";
import MaterialRequestDayButton from "../../shared/materialRequests/MaterialRequestDaysButton";
import { getCompanies } from "../../../services/api/companies";
import { ajaxErrorHandler, defaultSuccess } from "../../../libs/utils";
import { getEventMaterials } from "../../../services/api/eventMaterials";
import { useAllMaterialRequests } from "../../../hooks/api/material-requests/useAllMaterialRequests";
import { useCompanyMaterialRequests } from "../../../hooks/api/material-requests/useCompanyMaterialRequests";

class _MaterialRequestOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requests: [],
      requestsMeta: {},
      loaded: false,
      materials: [],
      baseFilters: toImmutable({
        "filter[event_id]": this.props.event.id,
        include: props.admin
          ? "material,days,registration,registration.company"
          : "material,days"
      }),
      filtered: false
    };

    this._getRequests = this._getRequests.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._getMaterialCategories = this._getMaterialCategories.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._daysBtn = this._daysBtn.bind(this);
    this._approve = this._approve.bind(this);
    this._reject = this._reject.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    admin: PropTypes.bool,
    event: PropTypes.object,
    materialRequestQuery: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    this._getRequests();
    this._getMaterialCategories();
  }

  componentDidUpdate(prevProps) {
    console.log(prevProps, this.props);
    if (prevProps.event.id !== this.props.event.id) {
      this.setState(
        {
          baseFilters: this.state.baseFilters.merge({
            "filter[event_id]": this.props.event.id
          })
        },
        this._getRequests
      );
    }
  }

  _getMaterialCategories() {
    if (!this.props.admin) {
      getRegistrationMaterialCategories(this.props.registration.id, {
        include: "material-category.children.material-requests"
      }).then(response => {
        let materials = [];
        response.data.forEach(cat => {
          if (cat.materialCategory.children) {
            cat.materialCategory.children.forEach(subcat => {
              materials = materials.concat(subcat.materials);
            });
          }
        });

        this.setState({
          materials
        });
      });
    } else {
      getEventMaterials(this.props.event.id, { include: "material" }).then(
        reponse => {
          this.setState({
            materials: reponse.data.map(eventMaterial => eventMaterial.material)
          });
        }
      );
    }
  }

  _getRequests(filters = this.state.baseFilters) {
    if (!this.props.admin) {
      getMaterialRequests(this.props.registration.id, filters).then(
        response => {
          this.setState({
            requests: response.data,
            requestsMeta: response.meta,
            loaded: true,
            baseFilters: filters
          });
        }
      );
    } else {
      getAllMaterialRequests(filters).then(response => {
        this.setState({
          requests: response.data,
          requestsMeta: response.meta,
          loaded: true,
          baseFilters: filters
        });
      });
    }
  }

  _handleDelete(id) {
    Confirm("Are you sure you want to delete this request?", {
      title: "Delete Material Request",
      confirmStyle: "btn-danger",
      confirmText: "Delete"
    }).then(
      result => {
        deleteMaterialRequest(this.props.registration.id, id).then(response =>
          this._getRequests()
        );
      },
      result => {}
    );
  }

  _approve(item) {
    approveMaterialRequest(item.registrationId, item.id)
      .then(response => {
        this._getRequests();
        defaultSuccess("Request has been approved");
      })
      .catch(ajaxErrorHandler);
  }

  _reject(item) {
    rejectMaterialRequest(item.registrationId, item.id)
      .then(response => {
        this._getRequests();
        defaultSuccess("Request has been rejected");
      })
      .catch(ajaxErrorHandler);
  }

  _daysBtn(item) {
    if (!this.props.admin) {
      return <MaterialRequestDayButton request={item} />;
    } else {
      return [
        <MaterialRequestDayButton
          request={item}
          key="days"
          admin
          registrationId={item.registrationId}
        />,
        <span key="approvereject">
          {(item.status === "pending" || item.status === "rejected") && (
            <span key="approve">
              <button
                className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this._approve(item)}
              >
                <span>
                  <i className="la la-check" />
                  <span>Approve</span>
                </span>
              </button>
            </span>
          )}

          {(item.status === "pending" || item.status === "approved") && (
            <span key="reject">
              <button
                className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this._reject(item)}
              >
                <span>
                  <i className="la la-close" />
                  <span>Reject</span>
                </span>
              </button>
            </span>
          )}
        </span>
      ];
    }
  }

  _handleFilterUpdate(filters) {
    this._getRequests(filters);
    this.setState({
      filtered: true
    });
  }

  render() {
    const {
      requests,
      requestsMeta,
      loaded,
      baseFilters,
      materials,
      filtered
    } = this.state;
    const { registration, admin, event, materialRequestQuery } = this.props;
    const { isLoading, data: materialRequests } = materialRequestQuery;

    const filters = [];

    if (admin) {
      columns.push({
        key: "company",
        value: "Company",
        render: request => request.registration.company.name
      });

      filters.push({
        label: "Company",
        icon: "la-building",
        type: "typeahead",
        options: value =>
          getCompanies({
            "filter[name]": value
          }),
        key: "company_id",
        labelKey: "name"
      });

      filters.push({
        label: "Status",
        icon: "la-calendar",
        type: "select",
        key: "current_status",
        dataset: [
          { key: "pending", value: "Pending" },
          { key: "approved", value: "Approved" },
          { key: "rejected", value: "Rejected" }
        ]
      });
    }

    const listViewConf = {
      dataSet: requests,
      dataMeta: requestsMeta,
      columns,
      filters,
      baseFilters: baseFilters,
      actions: {
        deleteLink: true,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: this._daysBtn
      },
      url: "/admin/material-requests"
    };

    return (
      <div className="m-content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title" />
                </div>

                <div className="m-portlet__head-tools">
                  <ul className="m-portlet__nav m--margin-left-20">
                    <li className="m-portlet__nav-item">
                      <CreateMaterialRequestButton
                        registration={registration}
                        materials={materials}
                        refreshRequests={this._getRequests}
                        admin={admin}
                        event={event}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                {loaded && (requests.length > 0 || filtered) && (
                  <ListView
                    config={listViewConf}
                    handleDelete={this._handleDelete}
                    handleFilterUpdate={this._handleFilterUpdate}
                  />
                )}

                {loaded && requests.length < 1 && !filtered && (
                  <div className="alert alert-info">
                    <Trans>noMaterialsRequestedYetMsg</Trans>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ({ admin, event, ...props }) => {
  const registration = useSelector(selectCompanyRegistration);

  const materialRequestQuery = useAllMaterialRequests(registration, {
    enabled: admin
  });
  const companyMaterialRequestQuery = useCompanyMaterialRequests(registration, {
    enabled: !admin
  });

  return (
    <MaterialRequestOverview
      registration={registration}
      admin={admin}
      materialRequestQuery={
        admin ? materialRequestQuery : companyMaterialRequestQuery
      }
      {...props}
    />
  );
};
